<template>
  <div class="sideview-container" ref="sideview-container">
    <div class="pj-container" ref="pjBox">
      <img :src="require('../../assets/parts/UST/' + pjImgType + '_side_left.png')" class="wall-plate" ref="wall-plate"/>
      <div>
        <img :src="require('../../assets/parts/UST/' + pjImgType + '_side_right2.png')"
         class="projector" ref="projector" :class="{'P2PJSize': pjImgType === 'P2'}"/>
        <div ref="vArrow" class="v-arrow arrowImg" :class="{pressArrowImg:vDragFlag}"
         @touchstart="onVTouchStart" @touchmove.prevent="onVTouchMove" @touchend="onVTouchEnd">
        </div>
        <div ref="hArrow" class="h-arrow arrowImg" :class="{pressArrowImg:hDragFlag}"
         @touchstart="onHTouchStart" @touchmove.prevent="onHTouchMove" @touchend="onHTouchEnd">
        </div>
      </div>
      <div class="wall-to-pjfront-arrow" :class="{'P2ArrowTop': pjImgType === 'P2'}">
        <ArrowItem :itemWidth='rightArrowLeft' color='#00bfff'></ArrowItem>
        <div class="number">(1)</div>
      </div>
    </div>
    <div class="screen" :style="{height:screenStatus.height +'rem',top:screenStatus.top + 'px',left:screenLeft + 'rem'}"
     :class="{'P2-screen': pjImgType === 'P2', 'ipad-screen': isIpad}">
      <img class="touchUnit" :class="{'P1-touchUnit': pjImgType === 'P1'}"  v-if='fingerTouchStatus' :src="require('../../assets/parts/UST/' + fingerUintUrl)"/>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import ArrowItem from './USTArrow'

export default {
  components: { ArrowItem },
  data () {
    return {
      sideViewWidth: 375, // 375px
      outOfRange: false,
      vDragFlag: false,
      hDragFlag: false,
      displayCeilingH: 400, // 图中房间高度为400 （px）
      draggableHeight: 150, // 显示区域为0.5m-2m范围 (cm)
      oldX: 0,
      oldY: 0,
      projectorLeft: 0,
      pjLeft: 0,
      screenStatus: { height: 0, top: 0 },
      isIpad: false
    }
  },
  computed: {
    ...mapState([
      'graph',
      'houseInfo',
      'fingerTouchStatus',
      'drawData',
      'selectedModelData',
      'isLatvia',
      'selectedLensData',
      'offset'
    ]),
    ...mapGetters(['unitLabel']),
    ceilingHFixed () { // (px)
      return this.displayCeilingH * this.houseInfo.roomH / this.draggableHeight
    },
    rightArrowLeft () {
      return this.pjLeft / 100 * 2.67
    },
    defaultWidth () {
      return this.isIpad ? 1000 : 400
    },
    fingerUintUrl () {
      let name = '120mm'
      let url = ''
      if (this.pjImgType === 'P2') {
        if (this.aspectRatio === '16:6' || this.aspectRatio === '21:9') {
          name = '60mm'
        } else {
          name = '46mm'
        }
      }
      url = this.pjImgType + '_side_foot_' + name + '.png'
      return url
    },
    lightOffset () {
      return this.pjImgType === 'P1' ? 94 : 98
    },
    wallPlateH: {
      get () {
        return this.isLatvia ? 58 : 70
      },
      set (value) {
      }
    },
    pjImgType () {
      return this.isLatvia ? 'P2' : 'P1'
    },
    offsetLength () {
      return this.offset * this.sideViewWidth / this.defaultWidth
    },
    screenLeft () {
      let val = this.pjImgType === 'P1' ? 50 : 57
      return (this.offsetLength + val) / 100 * 2.67
    }

  },
  watch: {
    drawData: {
      handler (val, oldVal) {
        if (val) {
          let value = this.isIpad ? 200 : 60
          let screenPArr = val[0]
          let screenH = screenPArr[3].z - screenPArr[0].z
          let height = (this.ceilingHFixed * screenH) / this.houseInfo.roomH / 100 * 2.67
          let top = ((screenPArr[0].z - this.houseInfo.roomH + 200) * this.ceilingHFixed) / this.houseInfo.roomH + value
          this.screenStatus = { height, top }
          let screenTopToCeilingVal = this.$commonJs.changeUnit(screenPArr[0].z, this.graph.unit, false, true)
          this.SET_SCREENTOPTOCEILING(screenTopToCeilingVal)
          let plateBottomToScreenVal = this.$commonJs.changeUnit(screenPArr[0].z - this.graph.pjZ + this.selectedLensData.lens2mptsHeight - this.selectedLensData.mpts2wallBottomHeight, this.graph.unit, false, true)
          this.SET_PLATEBOTTOMTOSCREEN(plateBottomToScreenVal)
          let plateTopToCeiling = this.$commonJs.changeUnit(this.graph.pjZ - this.selectedLensData.lens2mptsHeight + this.selectedLensData.mpts2wallBottomHeight, this.graph.unit, false, true)
          this.SET_PLATETOPTOCEILING(plateTopToCeiling)
          this.setPosition()
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations([
      'PJX',
      'PJZ',
      'PJY',
      'SCREENSIZE',
      'SCRNW',
      'SCRNH',
      'SET_SCREENTOPTOCEILING',
      'SET_PLATEBOTTOMTOSCREEN',
      'SET_PLATETOPTOCEILING']),
    onVTouchStart (e) {
      let ev = e.targetTouches[0]
      this.vDragFlag = true
      this.oldY = ev.clientY
      this.pjBoxTop = this.$refs['pjBox'].offsetTop
    },
    onVTouchMove (e) {
      if (this.vDragFlag) {
        let touch = e.targetTouches[0]
        let moveY = touch.clientY - this.oldY
        let pjTop = this.pjBoxTop + moveY
        if (pjTop <= -this.wallPlateH) {
          pjTop = -this.wallPlateH
        } else if (pjTop >= this.displayCeilingH - this.wallPlateH) {
          pjTop = this.displayCeilingH - this.wallPlateH
        }
        // this.$refs['pjBox'].style.top = pjTop + 'px'
        var pjzVal = this.houseInfo.roomH - 200 + (pjTop * this.draggableHeight / this.displayCeilingH)
        this.PJZ(pjzVal)
      }
    },
    onVTouchEnd () {
      this.vDragFlag = false
    },
    onHTouchStart (e) {
      let ev = e.targetTouches[0]
      this.hDragFlag = true
      this.oldX = ev.clientX
      this.projectorLeft = this.$refs['projector'].offsetLeft + this.lightOffset
      const { maxDis, minDis } = this.$commonViewJs.getMinDisByLens()
      this.maxDis = maxDis
      this.minDis = minDis
    },
    onHTouchMove (e) {
      if (this.hDragFlag) {
        let touch = e.targetTouches[0]
        let moveX = touch.clientX - this.oldX // 手指移动距离
        let pjLeft = this.projectorLeft + moveX
        let screenToLens = (pjLeft * this.defaultWidth) / this.sideViewWidth
        if (screenToLens <= this.minDis) {
          screenToLens = this.minDis
          pjLeft = screenToLens * this.sideViewWidth / this.defaultWidth
        } else if (screenToLens >= this.maxDis) {
          screenToLens = this.maxDis
          pjLeft = screenToLens * this.sideViewWidth / this.defaultWidth
        }

        this.PJY(screenToLens - this.offset)

        this.SCREENSIZE(this.$commonViewJs.getScreenByFromDistWide(screenToLens))
        let screen = this.$commonViewJs.getScreenXyFromDist(screenToLens)
        this.SCRNW(screen.calX)
        this.SCRNH(screen.calY)
      }
    },
    onHTouchEnd () {
      this.hDragFlag = false
    },
    setPosition () {
      this.pjLeft = (this.graph.pjY * this.sideViewWidth) / this.defaultWidth
      const pjTop = this.displayCeilingH * (this.graph.pjZ - (this.houseInfo.roomH - 200)) / this.draggableHeight
      if (this.$refs['pjBox']) {
        this.$refs['pjBox'].style.top = pjTop + 'px'
      }
      if (this.$refs['projector']) {
        this.isIpad = navigator.userAgent.indexOf('iPad') > -1
        this.$refs['projector'].style.left = (this.pjLeft - this.lightOffset) / 100 * 2.67 + 'rem'
      }
      if (this.$refs['hArrow']) {
        let val = this.isIpad ? 200 : 50
        this.$refs['hArrow'].style.left = this.pjLeft + val + 'px'
      }
    }
  },
  mounted () {
    this.isIpad = navigator.userAgent.indexOf('iPad') > -1
    if (this.isIpad) {
      this.sideViewWidth = this.$refs['sideview-container'].offsetWidth
      this.displayCeilingH = this.$refs['sideview-container'].offsetHeight
      this.wallPlateH = this.$refs['wall-plate'].offsetHeight
    }
    this.PJX(this.houseInfo.roomW / 2)
    this.setPosition()
  }
}
</script>
<style scoped>
.sideview-container {
  height: 400px;
  background: url('../../assets/parts/UST/bg_wall.png') no-repeat;
  background-size: cover;
  position: relative;
  overflow: hidden;
}
.pj-container {
  width: 100px;
  height: 80px;
  position: absolute;
  left: 55px;
}
.pj-container img {
  position: absolute;
}
.wall-plate {
  z-index: 10;
  height: 80px;
}
.projector {
  height: 269px;
}
.P2PJSize {
  height: 256px;
}
.screen {
  position: relative;
  width: 40px;
  height: 285px;
  background: url("../../assets/parts/UST/screen_side.png") no-repeat;
}
.ipad-screen {
  background-size: contain;
}
.P2-screen {
  left: 57px;
}
.number{
  margin-left: 10px;
  font-size:16px
}
.arrowImg {
  width: 34px;
  height: 95px;
  background: url("../../assets/parts/UST/btn_move.png") no-repeat;
  background-size: contain;
}
.pressArrowImg {
  background: url("../../assets/parts/UST/btn_move_up_pressed.png") no-repeat;
  background-size: contain;
}
.v-arrow {
  position: absolute;
  left: 195px;
}
.h-arrow {
  position: absolute;
  left: 120px;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
  top: 60px;
}
.wall-to-pjfront-arrow{
  position: absolute;
  left: 17px;
  top: 64px;
  z-index: 20;
}
.wall-to-pjfront-arrow.P2ArrowTop{
  top: 52px;
}
.touchUnit {
  height: 10px;
  position: absolute;
  top: -10px;
  left: 10px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
